import { RosterAttendeeType } from "amazon-chime-sdk-component-library-react";
import { Type } from "@themes/pollinator/ui/Type";
import { VideoUIRosterItemContainer } from "./VideoUIRosterItemContainer";

export type Props = {
  roster: RosterAttendeeType[];
};

export function VideoUIRoster({ roster }: Props) {
  let attendees = Object.values(roster);

  return (
    <div className="flex flex-col gap-8 px-4 py-8">
      <div className="flex flex-row gap-2 items-center">
        <Type variant="h3">Attendees</Type>
        <Type
          variant="caption"
          className="border border-brand-800 rounded-full p-1 w-6 h-6 flex items-center justify-center text-brand-800"
        >
          {attendees.length}
        </Type>
      </div>

      <div className="flex flex-col gap-4">
        {attendees.map((attendee: RosterAttendeeType) => {
          const { chimeAttendeeId } = attendee || {};
          return (
            <VideoUIRosterItemContainer
              key={chimeAttendeeId}
              attendeeId={chimeAttendeeId}
            />
          );
        })}
      </div>
    </div>
  );
}

export default VideoUIRoster;
